import EditModal from 'components/forms/EditModal'
import React from 'react'
import { Dropdown, Form, Menu } from 'semantic-ui-react'
import underscored from 'underscore.string/underscored'
import NewEntityModal from "../../entities/NewEntityModal";

const SelectorFieldControl = (props) => {
  const { name, required, readonly, entityId, selectOptions, translationScope } = props

  const selectedOption = getSelectedOption(selectOptions, entityId)

  return (
    <Form.Field>
      <label htmlFor={props.name}>
        {getLabel(name, props.name, translationScope)}{required ? "*" : null}
      </label>
      {readonly ? renderReadonlyValue(selectedOption) : (
        <React.Fragment>
          {renderDropdown(props)}
          {renderAddAndEditMenu(props)}
        </React.Fragment>
      )}
    </Form.Field>
  )
}

const renderDropdown = ({ multiple, selectOptions, handleChange, entityId, SideButton, dropdownProps, dropdownRef }) => {
  const selectorWrapperStyle = { display: 'flex' }
  const selectorStyle = { margin: 0, borderBottomRightRadius: 0, borderTopRightRadius: 0 }
  const sideButtonStyle = { borderBottomLeftRadius: 0, borderTopLeftRadius: 0 }

  const selectDropdown = (
    <Dropdown selection multiple={multiple} search options={selectOptions}
      onChange={handleChange} value={entityId} fluid ref={dropdownRef} {...(dropdownProps || {})}
    />
  )

  if (!SideButton) return selectDropdown

  const SelectSideButton = (props) => <SideButton {...props}/>
  return (
    <div style={selectorWrapperStyle}>
      <Dropdown selection multiple={multiple} search options={selectOptions} onChange={handleChange}
        value={entityId} fluid style={selectorStyle} ref={dropdownRef} {...(dropdownProps || {})}
      />
      <SelectSideButton style={sideButtonStyle}/>
    </div>
  )
}

const renderAddAndEditMenu = ({ uiSchema, EntityForm, entityId, entityName, handleChange }) => {
  const options = uiSchema?.["ui:options"] || {}
  const { addable, editable } = options

  return (
    <Menu compact icon borderless secondary>
      {addable && EntityForm ?
        <NewEntityModal entityName={entityName} form={EntityForm} handleSubmitSuccess={(id) => {
          handleChange(null, { value: id })
        }}/> : null}
      {(editable && entityId && EntityForm) ?
        <EditModal entityId={entityId} entityName={entityName} EntityForm={EntityForm}/> : null}
    </Menu>
  )
}

const getLabel = (name, fieldName, translationScope) => {
  if (fieldName === "id") return I18n.t(underscored(translationScope))
  return I18n.t(`${translationScope}.${underscored(name)}`)
}

const getSelectedOption = (selectOptions, entityId) => {
  return (selectOptions || []).find((option) => option.key === `${entityId}`)
}

const renderReadonlyValue = (selectedOption) => {
  return selectedOption && selectedOption.text || I18n.t('generic.unknown')
}

export default SelectorFieldControl;
